import { Reveal, ChapterHeader } from "./Reveal";
import { Warehouse, SquareStack, LandPlot, ArrowRight } from "lucide-react";
import { scrollToId } from "./Navbar";
import { useLang } from "../i18n";
import { useGallery } from "../gallery";

const IMG = "https://images.unsplash.com/photo-1624027492684-327af1fb7559?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxpbmR1c3RyaWFsJTIwd2FyZWhvdXNlJTIwZmFjdG9yeSUyMGludGVyaW9yJTIwaGVhdnklMjBtYWNoaW5lcnklMjBzdGVlbCUyMGNyYW5lfGVufDB8fHx8MTc4OTQ2OTU3NHww&ixlib=rb-4.1.0&q=85";

export const WarehouseSpaces = () => {
  const { t } = useLang();
  const { sections } = useGallery();
  const img = sections.warehouse ? `${process.env.REACT_APP_BACKEND_URL}${sections.warehouse.url}` : IMG;
  const AREAS = [
    { icon: Warehouse, value: "300,0 m²", label: t("area1l"), note: t("area1n") },
    { icon: SquareStack, value: "1 000,0 m²", label: t("area2l"), note: t("area2n") },
    { icon: LandPlot, value: "1 757,0 m²", label: t("area3l"), note: t("area3n") },
  ];

  return (
  <section data-testid="warehouse-section" className="bg-gunmetal border-y border-steelborder">
    <div className="py-20 lg:py-28 px-4 sm:px-8 max-w-7xl mx-auto">
      <ChapterHeader number="02" eyebrow={t("c2_eyebrow")} title={t("c2_title")} />

      <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
        <Reveal className="order-2 lg:order-1 lg:sticky lg:top-24">
          <div className="relative border border-steelborder">
            <div className="absolute -top-3 -right-3 w-16 h-16 border-t-2 border-r-2 border-safety z-10" />
            <div className="absolute -bottom-3 -left-3 w-16 h-16 border-b-2 border-l-2 border-safety z-10" />
            <img src={img} alt={t("c2_title")} className="w-full h-[420px] lg:h-[520px] object-cover spotlight-img" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent" />
            <div className="absolute bottom-4 left-4 font-mono text-xs tracking-[0.2em] uppercase text-slate-300 bg-ink/70 backdrop-blur px-3 py-1.5 border border-steelborder">
              {t("c2_img")}
            </div>
          </div>
        </Reveal>

        <div className="order-1 lg:order-2">
          <Reveal>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed mb-10">
              {t("c2_text")}
            </p>
          </Reveal>

          <div className="space-y-4">
            {AREAS.map((a, i) => (
              <Reveal key={a.label} delay={i * 0.08}>
                <div data-testid={`warehouse-card-${i}`}
                  className="group flex items-start gap-5 border border-steelborder bg-steelcard p-6 hover:border-safety/60 hover:-translate-y-0.5 transition-all duration-300">
                  <span className="flex items-center justify-center w-12 h-12 border border-steelborder bg-ink text-safety shrink-0 group-hover:bg-safety group-hover:text-ink transition-colors duration-300">
                    <a.icon className="w-6 h-6" />
                  </span>
                  <div className="flex-1">
                    <div className="flex items-baseline justify-between gap-4 flex-wrap">
                      <p className="font-heading text-xl font-bold uppercase tracking-wide text-slate-200">{a.label}</p>
                      <p className="font-mono text-xl font-bold text-safety">{a.value}</p>
                    </div>
                    <p className="text-sm text-slate-500 mt-1">{a.note}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.2}>
            <button onClick={() => scrollToId("#kontakt")} data-testid="warehouse-cta"
              className="group mt-10 flex items-center gap-3 border border-safety text-safety font-heading font-bold uppercase tracking-wide text-lg px-7 py-3.5 hover:bg-safety hover:text-ink transition-colors duration-300">
              {t("c2_cta")}
              <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
  );
};
